<section id="ngx-datatable-filter">
  <div class="row">
    <div class="col-12"></div>
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- ngx-datatable-filter -->
            <fieldset class="form-group">
              <div class="row align-items-end mt-0 pagination-body row-set-line">

                <div class="col-12 col-sm-12 col-md-5 col-lg-5">
                  <ng-select class="course-dropdown" [items]="courses" bindLabel="title" bindValue="_id"
                    placeholder="Select Course" [(ngModel)]="select_Course" [ngModelOptions]="{ standalone: true }"
                    [closeOnSelect]="false" (change)="getCourseId($event)">
                  </ng-select>
                </div>
                <div class="col-12 col-sm-12 col-md-7 col-lg-7">
                  <div class="d-flex align-items-center">

                    <div class="position-relative ml-2">
                      <input id="ngx-filter-ref"
                        class="form-control form-control-sm d-inline-block width-300 rounded-right shadow searchInput"
                        type="text" placeholder="Search" #name />
                      <button class="btn search-btn glow position-absolute">
                        <i class="ft-search text-white cursor-pointer"></i>
                      </button>
                    </div>

                    <div class="ml-2">
                      <button class="btn btn-primary btn-block users-list-clear glow mb-0 reset-btn">
                        Reset
                        <i class="ft-filter text-white cursor-pointer"></i>
                      </button>
                    </div>

                    <div class="ml-2"
                      *ngIf="user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                      <button type="button" class="btn btn-primary btn-block users-list-clear glow mb-0" placement="top"
                        ngbTooltip="Add New" (click)="addClass(select_Course)">
                        +
                      </button>
                    </div>
                    <div>
                      <i class="mx-2 cursor-pointer" placement="top" ngbTooltip="Multi-Connected"
                        (click)="checkMultiConnectByCourseId(connectOrNot,select_Course)"> <img src="assets/hexagon.svg"
                          alt=""> </i>
                      <i class="cursor-pointer" placement="top" ngbTooltip="Not Connected Yet"
                        (click)="checkNotConnectByCourseId(connectOrNot,select_Course)">
                        <img src="assets/pie-chart.svg" alt="">
                      </i>
                    </div>
                  </div>
                </div>
                <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                  [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                  [count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)"></ngx-datatable>



                <!-- <div class="col-12">
                    <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Classes Guideline</button>
                    </div> -->
              </div>
            </fieldset>
            <div class="ngx-datatable-container">
              <div cdkDropList (cdkDropListDropped)="onDrop($event)">
                <ngx-datatable *ngIf="rows?.length > 0" class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force"
                  [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows"
                  [scrollbarH]="true" [columns]="columns" [externalPaging]="true" [count]="page.totalPages"
                  [offset]="page.pageNumber" (page)="pageChangeData($event)">

                  <!-- Define ngx-datatable columns -->
                  <ngx-datatable-column name="Session Name" prop="title" [width]="80">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <div class="d-flex align-items-center cursor-pointer" cdkDrag>
                        {{ row?.title }}
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column name="Course" prop="course_id" [width]="80">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <div class="d-flex align-items-center">
                        {{ row?.course_id[0]?.title }}
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column name="Actions" [width]="80"
                    *ngIf="user_role.roles.includes('admin') || user_role.roles.includes('employee') || user_role.roles.includes('extractor')">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <i mat-button [matMenuTriggerFor]="menu1"
                        class="ft-more-vertical text-primary cursor-pointer mr-2"></i>

                      <mat-menu #menu1="matMenu">
                        <button mat-menu-item (click)="editSyllabus(row)">Syllabus Edit</button>
                        <button mat-menu-item (click)="editClass(row)">Edit</button>
                        <button mat-menu-item (click)="Delete(row?._id)">Delete</button>
                      </mat-menu>
                    </ng-template>
                  </ngx-datatable-column>

                </ngx-datatable>
              </div>

              <div *ngIf="rows.length === 0" class="align-items-center text-center d-flex justify-content-center m-5">
                No data found
              </div>
            </div>

            <!-- ngx-datatable-filter -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>

<!---------- Popup ---------------->
<div>
  <ng-template #connectOrNot let-modal>
    <div class="modal-header">
      <h4 class="modal-title" *ngIf="isMulitConnect">Multi Connected</h4>
      <h4 class="modal-title" *ngIf="isNotConnected">Not Connected</h4>

      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div *ngIf="isNotConnected">
        <div *ngIf="connectedOrNotConnected.length<1">
          There is no session.
        </div>
        <div *ngFor="let item of connectedOrNotConnected">
          <p><b>Topic Name :</b> {{item?.topic_name}}</p>
        </div>
      </div>
      <div *ngIf="isMulitConnect">
        <div *ngIf="connectedOrNotConnected.length<1">
          There is no session.
        </div>
        <div *ngFor="let item of connectedOrNotConnected">
          <p><b>Topic Name :</b> {{item?.topic_name}} &nbsp;
            <span><b>Connected Sessions :</b>
              <span *ngFor="let connectedItem of item?.connected_templates; let last = last">
                {{ connectedItem }}
                <ng-container *ngIf="!last">, </ng-container>
              </span>
            </span>
          </p>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
    </div>
  </ng-template>
</div>